import sections from "../../sections"

const INITIAL_State= {sections}

export const directoryReducer=(state=INITIAL_State,action)=>{
    switch (action.type){
        default:
            return state
    }

}
